import { render, staticRenderFns } from "./testSejda.vue?vue&type=template&id=59fd7cc1&scoped=true&"
import script from "./testSejda.vue?vue&type=script&lang=js&"
export * from "./testSejda.vue?vue&type=script&lang=js&"
import style0 from "./testSejda.vue?vue&type=style&index=0&id=59fd7cc1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fd7cc1",
  null
  
)

export default component.exports